import React from 'react';

import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { selectLoggedInEmployeeImage } from 'selectors/loggedInEmployee';
import styled from 'styled-components';

import ImageWithContent from './ImageWithContent';

export default function EnterComment({
  isEnterCommentActive,
  setIsEnterCommentActive,
  EditCommentComponent,
  placeholder,
  isLoggedInEmployeeComment = false,
  styleType = '',
  isDisabled,
  avatarSize = null,
  hideAvatar = false,
}) {
  function onFocus() {
    if (!isEnterCommentActive) {
      // updateEditorState(null);
      setIsEnterCommentActive(true);
    }
  }

  const employeeImageSrc = useSelector(selectLoggedInEmployeeImage);
  if (hideAvatar) {
    return (
      <Container>
        {isEnterCommentActive ? (
          EditCommentComponent
        ) : (
          <DummyTextField
            placeholder={placeholder && placeholder !== '' ? placeholder : 'Enter Comment'}
            onFocus={onFocus}
            disabled={isDisabled}
          />
        )}
      </Container>
    );
  }

  return (
    <ImageWithContent
      imageProps={{ src: employeeImageSrc }}
      align={isEnterCommentActive ? 'flex-start' : 'center'}
      isLoggedInEmployeeComment={isLoggedInEmployeeComment}
      styleType={styleType}
      avatarSize={avatarSize}
      content={
        <Container>
          {isEnterCommentActive ? (
            EditCommentComponent
          ) : (
            <DummyTextField
              placeholder={placeholder && placeholder !== '' ? placeholder : 'Enter Comment'}
              onFocus={onFocus}
              disabled={isDisabled}
            />
          )}
        </Container>
      }
    />
  );
}

export function EnterCommentV2({ EditCommentComponent, isLoggedInEmployeeComment = false, styleType = '' }) {
  const employeeImageSrc = useSelector(selectLoggedInEmployeeImage);
  return (
    <ImageWithContent
      imageProps={{ src: employeeImageSrc }}
      isLoggedInEmployeeComment={isLoggedInEmployeeComment}
      styleType={styleType}
      content={<Container>{EditCommentComponent}</Container>}
    />
  );
}

EnterComment.propTypes = {
  feedId: PropTypes.string.isRequired,
  setCommentsVisibility: PropTypes.func.isRequired,
};

const Container = styled.div`
  position: relative;
  // .MuiTextField-root {
  //   padding-right: 1rem;
  // }
  .MuiInputBase-root {
    padding-right: 0;
  }
  .MuiInputBase-input {
    padding-top: 9px;
    padding-bottom: 10px;
  }
`;

const DummyTextField = styled.input`
  width: 100%;
  border: 1px solid ${(props) => props.theme.palette.divider};
  height: 2rem;
  padding: 6px 16px;
  border-radius: 4px;
  font-size: ${(props) => props.theme.typography.caption.fontSize};
`;
